import { Link } from "react-router-dom";

interface NewsBreadcrumbProps {
  articleTitle?: string;
}

export default function NewsBreadcrumb({ articleTitle }: NewsBreadcrumbProps) {
  return (
    <nav className="w-full px-4 md:px-8 py-4 bg-gray-50">
      <div className="max-w-4xl mx-auto flex items-center gap-2 text-sm text-gray-500">
        <Link to="/" className="hover:text-navy transition-colors">
          ホーム
        </Link>
        <i className="ri-arrow-right-s-line text-xs" />
        <Link to="/news" className="hover:text-navy transition-colors">
          ニュース
        </Link>
        {articleTitle && (
          <>
            <i className="ri-arrow-right-s-line text-xs" />
            <span className="text-navy truncate max-w-[200px] md:max-w-md">
              {articleTitle}
            </span>
          </>
        )}
      </div>
    </nav>
  );
}
